import React from 'react';

export const LazyHypeHeader = React.lazy(() =>
  import(/* webpackChunkName: "hype" */ './HypeHeader/HypeHeader'),
);

export const LazyHypeRoute = React.lazy(() =>
  import(/* webpackChunkName: "hype" */ './Route'),
);

export const LazyHypeFooter = React.lazy(() =>
  import(/* webpackChunkName: "hype" */ './HypeFooter/HypeFooter'),
);
